import api from "@/assets/js/api.js"; // 引入 api.js

export default {
  data() {
    return {
      member: {
        email: "",
        fullName: "",
        phone: "",
        birth: "",
      },
      orders: [], // 從後端獲取的訂單數據
      filteredOrders: [], // 篩選後的訂單
      currentOrderFilter: "全部", // 當前訂單篩選條件
    };
  },
  methods: {
    async fetchMemberInfoAndOrders() {
      try {
        const response = await api.get(`/Order/MyOrders`);
        const data = response.data;

        // 訂單資料
        this.orders = data;
        this.filteredOrders = data;

        // 如果你想顯示使用者 email，可以從 localStorage 抓（但不影響查詢）
        const email = localStorage.getItem("userEmail");
        if (email) {
          this.member.email = email;
        }
      } catch (error) {
        console.error("無法獲取訂單：", error);
      }
    },
    filterOrders(filter) {
      this.currentOrderFilter = filter;
      if (filter === "全部") {
        this.filteredOrders = this.orders;
      } else {
        this.filteredOrders = this.orders.filter(
          (order) =>
            (filter === "已付款" && order.PaymentStatus === "已付款") ||
            (filter === "未付款" && order.PaymentStatus === "未付款") ||
            (filter === "已完成" && order.OrderStatus === "已完成") ||
            (filter === "已取消" && order.OrderStatus === "已取消")
        );
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("zh-TW", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  mounted() {
    this.fetchMemberInfoAndOrders();
  },
};
